import { BLOCK_WS, BLOCK_WS_SUCCESS, BLOCK_WS_ERROR} from './actionTypes';

const initialState = {
    errorBlockWs: "",
    loadingBlockWs: false,
    successBlockWs: ""
}

const blockWorkstations = (state = initialState, action) => {
    switch (action.type) {
        case BLOCK_WS:
            state = {
                ...state,
                loadingBlockWs: true
            }
            break;
        case BLOCK_WS_SUCCESS:
            state = {
                ...state,
                loadingBlockWs: false,
                successBlockWs: action.payload.message
            }
            break;
        case BLOCK_WS_ERROR:
            state = { ...state, errorBlockWs: action.payload, loadingBlockWs: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default blockWorkstations;